import React, { useMemo, useState } from "react";

const ScheduleChkDirectorAssignPanel = ({
  employees = [],
  hoursByEmployee = {},
  ftIds = new Set(),
  selectedEmployeeId,
  onSelect,
  filledCount = 0,
  slotCount = 0,
  disabled = false,
  message,
}) => {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const needle = query.trim().toLowerCase();
    const source = Array.isArray(employees) ? employees : [];
    const list = source.filter((user) => {
      if (!needle) return true;
      const hay = `${user.surname ?? ""} ${user.name ?? ""} ${user.post_name ?? ""}`.toLowerCase();
      return hay.includes(needle);
    });
    return list.sort((a, b) => {
      const hoursA = hoursByEmployee[a.id] || hoursByEmployee[Number(a.id)] || 0;
      const hoursB = hoursByEmployee[b.id] || hoursByEmployee[Number(b.id)] || 0;
      if (hoursA !== hoursB) return hoursA - hoursB;
      return `${a.surname} ${a.name}`.localeCompare(`${b.surname} ${b.name}`, "ru");
    });
  }, [employees, hoursByEmployee, query]);

  const selected = (Array.isArray(employees) ? employees : []).find(
    (user) => Number(user.id) === Number(selectedEmployeeId),
  );

  return (
    <aside className="schedule-chk-assign-panel">
      <div className="schedule-chk-assign-panel-head">
        <h4>Назначение</h4>
        <p>
          {slotCount > 0
            ? `Занято ${filledCount} из ${slotCount} слотов`
            : "Выберите сотрудника, затем кликните по слоту"}
        </p>
      </div>

      {disabled && (
        <div className="schedule-chk-assign-note">
          После согласования ТУ изменения только через служебную записку —
          клик по слоту откроет окно.
        </div>
      )}

      {selected ? (
        <div className="schedule-chk-assign-selected">
          Ставите: <b>{selected.surname} {selected.name}</b>
          <span>
            {hoursByEmployee[selected.id] || hoursByEmployee[Number(selected.id)] || 0} ч
            {ftIds.has(Number(selected.id)) ? " · FT" : ""}
          </span>
          <button type="button" onClick={() => onSelect(null)}>
            Сбросить
          </button>
        </div>
      ) : (
        <div className="schedule-chk-assign-selected is-empty">
          Сотрудник не выбран — клик по слоту откроет обычное окно
        </div>
      )}

      <input
        type="search"
        className="form-control form-control-sm"
        placeholder="Поиск по ФИО"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {message && (
        <div
          className={`schedule-chk-assign-message ${
            message.type === "error" ? "is-error" : "is-ok"
          }`}
        >
          {message.text}
        </div>
      )}

      <ul className="schedule-chk-assign-list">
        {filtered.map((user) => {
          const hours = hoursByEmployee[user.id] || hoursByEmployee[Number(user.id)] || 0;
          const active = Number(selectedEmployeeId) === Number(user.id);
          return (
            <li key={user.id}>
              <button
                type="button"
                className={`schedule-chk-assign-person ${active ? "is-active" : ""}`}
                onClick={() => onSelect(active ? null : user.id)}
              >
                <span className="schedule-chk-assign-person-name">
                  {user.surname} {user.name}
                  {ftIds.has(Number(user.id)) && (
                    <span className="schedule-chk-ft-badge">FT</span>
                  )}
                </span>
                <span className="schedule-chk-assign-person-meta">
                  {user.post_name}
                  <strong>{hours} ч</strong>
                </span>
              </button>
            </li>
          );
        })}
        {filtered.length === 0 && (
          <li className="schedule-chk-assign-empty">Никого не найдено</li>
        )}
      </ul>
    </aside>
  );
};

export default ScheduleChkDirectorAssignPanel;
